/* tslint:disable */
/* eslint-disable */
export enum PayPalEventDeliveryStatusEnum {
  Received = 'Received',
  Processed = 'Processed',
  Failed = 'Failed'
}
